const autoNgTemplateLoaderTemplate1 = require('./logs.html');

angular.module('portainer.nomad').component('logsController', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'LogsController',
});
